// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"0ea31ac7","263":"c352a2e5"}[chunkId] + ".chunk.js";
};